<select class="form-select form-select-sm"
        name="fieldAction"
        [ngModel]="selectedAction"
        (ngModelChange)="fieldActionChanged($event)"
        [disabled]="disabled">
    @for (pa of possibleActions; track pa) {
        <option [ngValue]="pa.value">{{ pa.name }}</option>
    }
</select>
